<div class="cart-container" rt="app-header-cart">
  <button
    #trigger
    type="button"
    class="cart-trigger"
    aria-haspopup="dialog"
    [attr.aria-expanded]="isOpen"
    [attr.aria-controls]="panelId"
    [attr.aria-disabled]="disableClick || null"
    [attr.aria-label]="triggerLabel"
    (click)="toggle()"
  >
    <span class="circle" [class.active]="badgeCount > 0" [class.dark]="darkTheme"></span>
    <span class="number-of-items" [class.active]="badgeCount > 0" [class.dark]="darkTheme">{{ badgeCount }}</span>
    <i class="icon-shopping-cart" [class.dark]="darkTheme" aria-hidden="true"></i>
  </button>
</div>
<div class="cart-backdrop" [class.is-open]="isOpen" (click)="close()" aria-hidden="true"></div>
<app-header-cart-panel
  [panelId]="panelId"
  [open]="isOpen"
  [rentalCount]="numberOfItemsInCart"
  [shopCount]="numberOfShopItems"
  [showShop]="storefrontEnabled"
  (dismiss)="close($event)"
></app-header-cart-panel>
